<div class="min-h-screen bg-[linear-gradient(to_right,transparent_100%,#ffffff),url('images/front-pages/abstract_loomis.png')] dark:bg-[linear-gradient(to_right,transparent_30%,#000000_80%),url('images/front-pages/abstract_loomis.png')] bg-cover bg-center">
    <app-order-navbar />
    <router-outlet />
    <app-fp-footer />
</div>

